//Built-in libraries
//Third party libraries
import { Routes, Route } from 'react-router-dom';

//Custom components
import ApplicationSubmitSuccess from './ApplicationSubmitSuccess';
import PageNotFound from '../PageNotFound';
import { CCLFForm } from '../../components/Applications/CCLFForm';
import { HandHousingForm } from '../../components/Applications/HandHousingForm';

//Services
import { useCurrentAccountData } from '../../hooks/ReactQueryHooks/useCurrentAccountQuery';

//Assets and Miscellaneous
import AccountNotFound from '../../components/UI/AccountNotFound';
import EnterpriseLBAForm from '../../components/Applications/EnterpriseLBAForm';
import ClientApplicationChecklist from '../../components/Applications/ClientApplication/ClientApplicationChecklist';

// import ApplicationForm from '../../components/Applications/ApplicationForm';
import useEnvironment from '../../hooks/useEnvironment';
import ApplicationSubmitFail from './ApplicationSubmitFail';
import { ApplicationForm } from 'features/ApplicationForm';
import { ApplicationFormLayout } from 'features/ApplicationForm/Components/ApplicationFormLayout';

const Applications = () => {
  const currentAccountInfo = useCurrentAccountData({});
  const accountSubdomain = currentAccountInfo?.data?.data?.subdomain;
  const { isDev } = useEnvironment();

  if (!accountSubdomain && !currentAccountInfo.isLoading) {
    return <AccountNotFound />;
  } else {
    return (
      <Routes>
        <Route path='/' element={<ApplicationFormLayout />}>
          {/* {isDev && (
          <Route
            path='form'
            element={
              <ApplicationForm
                title='Demo Application'
                signAsset={async () => {
                  return {
                    key: '',
                    path: '',
                    url: '',
                  };
                }}
                steps={baseApplicationSteps}
                onSubmit={async (values) => {
                  console.log(values);
                }}
              />
            }
          />
        )} */}
          {accountSubdomain === 'chicagorebuild' && (
            <Route
              path='client-application'
              element={
                <ClientApplicationChecklist>
                  <CCLFForm />
                </ClientApplicationChecklist>
              }
            />
          )}
          {(isDev || accountSubdomain === 'letsbuildaccelerator') && (
            <>
              <Route path='partner-proposal' element={<EnterpriseLBAForm />} />
            </>
          )}
          {(accountSubdomain === 'equityinaction' ||
            accountSubdomain === 'azizcorp') && (
            <Route path='client-application' element={<HandHousingForm />} />
          )}
          <Route path=':applicationFormId'>
            <Route index element={<ApplicationForm />} />
            <Route
              path='submit_success'
              element={<ApplicationSubmitSuccess />}
            />
            <Route path='submit_failed' element={<ApplicationSubmitFail />} />
          </Route>

          <Route path='submit-success' element={<ApplicationSubmitSuccess />} />
          <Route path='submit-failed' element={<ApplicationSubmitFail />} />
          <Route path='*' element={<PageNotFound />} />
        </Route>
      </Routes>
    );
  }
};

export default Applications;
